<template>
  <div class="welcome-strip d-print-none">
    <div class="welcome-card">
      <div class="welcome-user">
        <img
          v-if="!$store.getters['User/getProfile'].image"
          src="../../../../public/profile.webp"
          alt=""
        >
        <img
          v-else
          class="welcome-avatar"
          :src="$store.getters['User/getProfile'].image"
          alt="profile"
        >
        <div>
          <strong>{{ fullName }}</strong>
          <span>خوش آمدید</span>
        </div>
      </div>

      <div class="welcome-actions">
        <router-link
          class="welcome-action"
          :to="{name:'UserWallets',params:{user:$store.getters['User/getProfile'].id}}"
        >
          <img src="../../../../public/coin.webp" alt="">
          <span>مدیریت کیف پول</span>
        </router-link>
        <router-link class="welcome-action" :to="{name: 'Address'}">
          <img src="../../../../public/adress.webp" alt="">
          <span>آدرس‌های من</span>
        </router-link>
        <router-link class="welcome-action" :to="{name: 'CurrentUserFormFills'}">
          <img src="../../../../public/form.webp" alt="">
          <span>فرم‌های من</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardMobileProfile",
  computed: {
    fullName() {
      const profile = this.$store.getters['User/getProfile'] || {}
      return ((profile.name || '') + ' ' + (profile.last_name || '')).trim()
    },
  },
}
</script>

<style scoped>
.welcome-strip {
  overflow: hidden;
  margin-bottom: 12px;
}

.welcome-card {
  position: relative;
  background: linear-gradient(120deg, #1e1e1e 0%, #2a1d22 62%, #3b1d2a 100%);
  color: #fff;
  border-radius: 20px;
  padding: 16px 18px;
  overflow: hidden;
}

.welcome-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(rgba(255, 255, 255, 0.07) 1px, transparent 1px),
    linear-gradient(135deg, rgba(235, 61, 96, 0.2), transparent 50%);
  background-size: 14px 14px, auto;
  pointer-events: none;
}

.welcome-card > * {
  position: relative;
  z-index: 1;
}

.welcome-user {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.welcome-user img,
.welcome-avatar {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.12);
}

.welcome-user strong,
.welcome-user span {
  display: block;
}

.welcome-user span {
  opacity: 0.8;
  font-size: 12px;
}

.welcome-actions {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.welcome-action {
  min-width: 0;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  padding: 10px 8px;
  text-align: center;
  color: #fff !important;
  text-decoration: none !important;
  overflow: hidden;
}

.welcome-action img {
  height: 36px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  margin-bottom: 6px;
}

.welcome-action span {
  display: block;
  font-size: 12px;
  font-weight: 700;
}

.welcome-action >>> * {
  color: #fff !important;
}

.welcome-action >>> h4,
.welcome-action >>> h5,
.welcome-action >>> h6 {
  font-size: 12px;
  margin: 0;
}
</style>
